import React from 'react';
import { MainNavigationBar } from '../component/navigation-bar/MainNavigationBar';
import { MainPageLayout } from '../layout/MainPageLayout';
import { UserDiv } from '../component/users/UsersDiv';

export const UserPage = () => (
  <MainPageLayout
    navigationBar={<MainNavigationBar />}
    elementCentr={<UserDiv />}
  />
);
